import React from "react";

export {WAMTBPError};

const WAMTBPError = (props: any) => {
  
  return(<></>);
};